var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconInstantFund(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "delete",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.439,
    height: 25.439,
    viewBox: "0 0 25.439 25.439",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M0,0H25.439V25.439H0Z",
    transform: "translate(0 0)",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_872",
    "data-name": "Group 872",
    transform: "translate(3.353 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M10.528,7.024a9.328,9.328,0,1,0,9.328,9.328A9.332,9.332,0,0,0,10.528,7.024Zm0,1.7A7.632,7.632,0,1,1,2.9,16.351,7.636,7.636,0,0,1,10.528,8.72ZM9.68,1.088V4.48a.848.848,0,0,0,1.7,0V1.088a.848.848,0,0,0-1.7,0Zm-3.392.848V5.328a.848.848,0,0,0,1.7,0V1.936a.848.848,0,1,0-1.7,0Zm10.176,1.7V7.024a.848.848,0,1,0,1.7,0V3.632a.848.848,0,1,0-1.7,0ZM2.9,3.632V7.024a.848.848,0,1,0,1.7,0V3.632a.848.848,0,0,0-1.7,0Zm10.176-1.7V5.328a.848.848,0,1,0,1.7,0V1.936a.848.848,0,1,0-1.7,0Z",
    transform: "translate(-1.2 -0.24)",
    fill: "#0072bc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M5.184,9.9H8.576a.848.848,0,0,1,0,1.7H5.184a.846.846,0,0,1-.848-.848.848.848,0,0,0-1.7,0A2.542,2.542,0,0,0,5.184,13.3h.848v.848a.848.848,0,1,0,1.7,0V13.3h.848a2.542,2.542,0,0,0,2.544-2.544h0A2.542,2.542,0,0,0,8.576,8.208H5.184a.848.848,0,1,1,0-1.7H8.576a.846.846,0,0,1,.848.848.848.848,0,1,0,1.7,0A2.542,2.542,0,0,0,8.576,4.816H7.728V3.968a.848.848,0,1,0-1.7,0v.848H5.184A2.542,2.542,0,0,0,2.64,7.36h0A2.542,2.542,0,0,0,5.184,9.9Z",
    transform: "translate(2.448 7.056)",
    fill: "#0072bc",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInstantFund);
export default __webpack_public_path__ + "static/media/icon-instant-fund.c7f946c194111bfb3c715e043928b46c.svg";
export { ForwardRef as ReactComponent };